// extracted by mini-css-extract-plugin
export default {"backgroundDesktop":"Background_backgroundDesktop__12GEE","backgroundLogin":"Background_backgroundLogin__7k0Ve"};